module.exports = __webpack_public_path__ + "static/costs-2011.af17f379.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/exhibit10/costs-2011.png
// module id = 1331
// module chunks = 242809538932529